export default "__VITE_ASSET__DTDDx$pC__"